export const ourProducts2 = [
    {
        name: 'Для производственников',
        products: [
            {
                productName: "1С ERP Предприятие",
                info: {
                    text: "Комплексное управление производством",
                    additionalText: "Решение для автоматизации ключевых бизнес-процессов: от закупок и планирования до производства, логистики и продаж. Подходит для средних и крупных предприятий."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 4
            },
            {
                productName: "1С комплексное управление финансами и бюджетирование",
                info: {
                    text: "Контроль финансов в одной системе",
                    additionalText: "Система позволяет централизованно управлять финансами, планировать бюджеты, анализировать отклонения и повышать прозрачность финансовой отчетности компании."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 55
            },
            {
                productName: "Документооборот",
                info: {
                    text: "Упрощение бумажной рутины",
                    additionalText: "Электронный документооборот помогает организовать хранение, согласование и контроль исполнения документов, снижая количество бумажной работы и повышая скорость процессов."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 10
            },
            {
                productName: "Управление складом (WMS)",
                info: {
                    text: "Оптимизация складской логистики",
                    additionalText: "WMS-система автоматизирует приёмку, хранение и отгрузку товаров. Повышает точность учета, ускоряет операции и минимизирует ошибки персонала."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 35
            },
            {
                productName: "Учет спецодежды",
                info: {
                    text: "Автоматизация выдачи и списания",
                    additionalText: "Система позволяет отслеживать выдачу, срок носки и возврат спецодежды и СИЗ, вести учет по сотрудникам и подразделениям, контролировать нормативы и расходы."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 1
            },
            {
                productName: "1С Техобслуживание и ремонт",
                info: {
                    text: "Учет ремонтов и ТО оборудования",
                    additionalText: "Система помогает планировать и контролировать техническое обслуживание, вести журнал ремонтов, снижать простои и повышать надежность оборудования."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 19
            },
            {
                productName: "Закупки",
                info: {
                    text: "Автоматизация процессов снабжения",
                    additionalText: "Решение для управления закупками: от подачи заявки до заключения договора. Помогает снизить издержки, стандартизировать процессы и контролировать бюджет."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 20
            },
            {
                productName: "Казначейство",
                info: {
                    text: "Контроль движения денежных средств",
                    additionalText: "Модуль автоматизирует планирование, контроль и исполнение платежей, управление заявками на оплату, прогнозирование кассовых разрывов."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 18
            },
            {
                productName: "Автоматизация питания сотрудников",
                info: {
                    text: "Простая организация корпоративного питания",
                    additionalText: "Решение позволяет вести учет питания сотрудников, учитывать льготы, составлять меню и отчеты, оптимизировать закупки продуктов."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 1
            },
            {
                productName: "Управление автотранспортом (TMS) и путевые листы",
                info: {
                    text: "Контроль за автопарком предприятия",
                    additionalText: "Система TMS позволяет вести учет транспорта, маршрутов и путевых листов, контролировать расходы на топливо, планировать ТО и загрузку автомобилей."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 1
            },
            {
                productName: "Интеграция с промышленным оборудованием",
                info: {
                    text: "Связь 1С с реальным производством",
                    additionalText: "Модуль обеспечивает обмен данными между 1С и промышленными станками, датчиками и системами управления. Ускоряет производственные процессы и снижает ручной труд."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 1
            },
            {
                productName: "1С промышленная безопасность",
                info: {
                    text: "Учет и контроль опасных объектов",
                    additionalText: "Решение для управления мероприятиями по промышленной безопасности: ведение инструктажей, учет проверок и инцидентов, контроль выполнения требований законодательства."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 27
            }
        ]
    },
    {
        name: "Кибернетика для холдингов",
        products: [
            {
                productName: "CasPlan",
                info: {
                    text: "Аналитика и прогнозирование на новом уровне",
                    additionalText: "Решения класса Business Intelligence для построения дашбордов, отчетов и моделей планирования. Обеспечивают прозрачность и управляемость бизнесом на всех уровнях."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 72
            },
            {
                productName: "Система ETL и DWH",
                info: {
                    text: "Единая витрина данных холдинга",
                    additionalText: "Инструмент для извлечения, трансформации и загрузки данных (ETL) в централизованное хранилище (DWH). Обеспечивает консолидацию информации из разных систем и повышает качество управленческой аналитики."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 1
            },
            {
                productName: "Казначейство",
                info: {
                    text: "Централизация финансовых потоков",
                    additionalText: "Позволяет управлять платежами всех компаний группы, контролировать остатки, заявки на оплату и движение денежных средств в разрезе юридических лиц."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 18
            },
            {
                productName: "Управление договорами",
                info: {
                    text: "Контроль договорной деятельности",
                    additionalText: "Система автоматизирует процессы подготовки, согласования и исполнения договоров в холдинге. Поддерживает единые шаблоны, маршруты согласования и учет сроков."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 21
            },
            {
                productName: "Документооборот",
                info: {
                    text: "Упорядоченный документооборот в группе компаний",
                    additionalText: "Система электронного документооборота с разграничением прав и маршрутов по организациям. Поддерживает цифровую подпись, архив и учет исполнительской дисциплины."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 10
            },
            {
                productName: "Закупки",
                info: {
                    text: "Управление закупками на уровне холдинга",
                    additionalText: "Позволяет централизовать потребности, проводить тендеры, контролировать бюджеты и формировать единую закупочную стратегию для всех дочерних компаний."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 20
            },
            {
                productName: "Бюджетирование",
                info: {
                    text: "Планирование бюджета по всем структурам",
                    additionalText: "Автоматизация процессов формирования, согласования и мониторинга исполнения бюджетов с возможностью сводного анализа по всей группе компаний."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 6
            },
            {
                productName: "Системы планирования и BI",
                info: {
                    text: "Аналитика и прогнозирование на новом уровне",
                    additionalText: "Решения класса Business Intelligence для построения дашбордов, отчетов и моделей планирования. Обеспечивают прозрачность и управляемость бизнесом на всех уровнях."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 8
            },
            {
                productName: "Учет по стандартам МСФО на отдельном плане счетов",
                info: {
                    text: "МСФО-учет в параллели с РСБУ",
                    additionalText: "Позволяет вести учет по МСФО на отдельном плане счетов, формировать отчетность для холдинга и инвесторов, не нарушая основные принципы регламентированного учета."
                },
                feautures: {
                    "price": 10000,
                    "time": "От 1 до 4 месяцев"
                },
                id: 1
            }
        ]
    },
    {
        name: '1С Рейтинг',
        products: [
            {
                productName: '1С-Рейтинг: Нефтебаза',
                info: {
                    text: 'Учёт ГСМ и операций нефтебазы',
                    additionalText: 'Автоматизация учёта нефтепродуктов: поступление, хранение, реализация. Поддержка резервуарного парка, типовых форм и требований учёта ГСМ.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 67
            },
            {
                productName: '1С-Рейтинг: Бухгалтерия автотранспортного предприятия',
                info: {
                    text: 'Учёт и отчётность для АТП',
                    additionalText: 'Решение учитывает специфику автотранспортных предприятий: путевые листы, ГСМ, ремонты, учет выручки, налоговый и бухгалтерский учёт.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 70
            },
            {
                productName: '1С-Рейтинг: Алкомониторинг',
                info: {
                    text: 'Учёт и контроль алкоголя по ЕГАИС',
                    additionalText: 'Система автоматизирует обмен с ЕГАИС, позволяет вести учёт алкоголя, формировать отчёты и контролировать движение продукции в соответствии с законодательством.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 64
            },
            {
                productName: '1С:Бухгалтерия строительной организации для Казахстана',
                info: {
                    text: 'Бухучёт с учётом строительной специфики',
                    additionalText: 'Автоматизация бухгалтерского и налогового учета с поддержкой договоров подряда, актов КС-2, КС-3, учёта по объектам строительства.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 66
            },
            {
                productName: '1С-Рейтинг: Автотранспортное предприятие',
                info: {
                    text: 'Полный контроль автопарка',
                    additionalText: 'Учёт путевых листов, расхода топлива, ремонтов, маршрутов и водителей. Подходит для транспортных и логистических компаний.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 68
            },
            {
                productName: '1С-Рейтинг: Управление затратами на автотранспорт. Путевые листы',
                info: {
                    text: 'Оптимизация расходов на транспорт',
                    additionalText: 'Учет путевых листов, затрат на ГСМ, ремонты, пробеги и начисление зарплаты водителям. Помогает анализировать и снижать транспортные расходы.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 69
            },
            {
                productName: '1С-Рейтинг: Бюджетирование предприятия',
                info: {
                    text: 'Планирование и контроль бюджета',
                    additionalText: 'Инструмент для формирования, согласования и анализа бюджетов. Помогает контролировать исполнение финансовых планов предприятия.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 62
            },
            {
                productName: '1С-Рейтинг: Комплексное управление финансами и бюджетированием для Казахстана',
                info: {
                    text: 'Централизованное управление финансами',
                    additionalText: 'Решение адаптировано под требования законодательства РК. Объединяет учёт, бюджетирование и финансовое планирование в единой системе.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 63
            },
            {
                productName: '1С-Рейтинг: Управление финансами строительной организации для Казахстана',
                info: {
                    text: 'Финансовый контроль стройки',
                    additionalText: 'Учет и контроль движения средств по объектам строительства, план-факт анализ, поддержка подряда и субподряда, отражение затрат в разрезе проектов.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 65
            },
            {
                productName: '1С-Рейтинг: Бухгалтерия автотранспортного предприятия',
                info: {
                    text: 'Учёт и отчётность для АТП',
                    additionalText: 'Решение учитывает специфику автотранспортных предприятий: путевые листы, ГСМ, ремонты, учет выручки, налоговый и бухгалтерский учёт.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 70
            },
            {
                productName: '1С-Рейтинг: Учет спецодежды и инвентаря ред. 3.0',
                info: {
                    text: 'Учёт и списание спецодежды',
                    additionalText: 'Автоматизация выдачи, возврата и списания СИЗ и инвентаря. Поддержка учёта по нормам, срокам носки, сотрудникам и подразделениям.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 71
            }
        ]
    },
    {
        name: '1С Совместимо',
        products: [
            {
                productName: 'Настройка разграничения прав к заработной плате на счетах учета',
                info: {
                    text: 'Контроль доступа к данным по зарплате',
                    additionalText: 'Позволяет разграничить права доступа сотрудников к информации о начислениях и выплатах заработной платы на уровне счетов учета. Усиливает конфиденциальность и управляемость данных.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },

        ]
    },
    {
        name: 'Мобильные решения',
        products: [
            {
                productName: 'Агент+',
                info: {
                    text: 'Автоматизация работы торговых представителей',
                    additionalText: 'Мобильное решение для выездной торговли и мерчендайзинга. Позволяет оформлять заказы, контролировать остатки, фиксировать визиты и собирать аналитику в полях.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 15
            },
            {
                productName: 'MobiC',
                info: {
                    text: 'Универсальная мобильная платформа для бизнеса',
                    additionalText: 'Мобильное приложение для автоматизации процессов: продажи, логистика, складской учёт. Легко интегрируется с 1С и другими учетными системами.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Нативные мобильные приложения',
                info: {
                    text: 'Индивидуальные приложения под iOS и Android',
                    additionalText: 'Разработка мобильных приложений с нуля, под конкретные задачи бизнеса. Высокая производительность, гибкий UI, полная интеграция с внутренними системами.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Мобильные приложения на базе 1С Предприятия',
                info: {
                    text: '1С в кармане — всегда под рукой',
                    additionalText: 'Создание мобильных решений с использованием платформы 1С:Предприятие. Подходят для автоматизации выездной торговли, логистики и мобильного документооборота.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
        ]
    },
    {
        name: 'Услуги сопровождения',
        products: [
            {
                productName: 'Техническая поддержка и обновление',
                info: {
                    text: 'Надёжность и актуальность ваших решений',
                    additionalText: 'Регулярное обновление конфигураций 1С, устранение ошибок, консультации пользователей и контроль корректной работы систем. Поддержка на всех этапах работы.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Интеграции систем',
                info: {
                    text: 'Объединение данных из разных систем',
                    additionalText: 'Создание мостов между 1С и другими ИТ-системами: CRM, склад, сайт, банковские сервисы и прочее. Повышает эффективность и исключает двойной ввод данных.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Ускорение 1С',
                info: {
                    text: 'Быстрая и отзывчивая 1С',
                    additionalText: 'Диагностика и оптимизация производительности 1С. Устраняем "тормоза", оптимизируем запросы, улучшаем работу с базой данных и сервером.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: '1С ИТС',
                info: {
                    text: 'Официальная поддержка от 1С',
                    additionalText: 'Оформление и сопровождение договора ИТС: доступ к обновлениям, консультации от специалистов 1С, информационная база, методическая помощь.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Переход с MS SQL на Postgree',
                info: {
                    text: 'Экономия без потери функциональности',
                    additionalText: 'Миграция с коммерческой СУБД Microsoft SQL Server на бесплатную PostgreSQL. Сохраняем структуру и работоспособность решений, оптимизируем ресурсы.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            }
        ]
    },
    {
        name: 'Планирование и консолидация',
        products: [
            {
                productName: 'Система ETL и DWH',
                info: {
                    text: 'Хранилище данных для управленческой отчётности',
                    additionalText: 'Собирает и структурирует данные из разных источников. Обеспечивает единую точку правды для анализа и отчетности на уровне всей компании или холдинга.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Системы интегрированного планирования',
                info: {
                    text: 'Согласованное планирование по подразделениям',
                    additionalText: 'Позволяют объединить операционные, финансовые и стратегические планы в одной системе. Поддерживают многовариантность, сценарное моделирование и контроль исполнения.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'BI-дашборды',
                info: {
                    text: 'Визуализация ключевых показателей',
                    additionalText: 'Интерактивные панели мониторинга, отражающие KPI, финансы, продажи, производство и другие процессы. Обновляются в реальном времени, помогают принимать решения быстрее.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Бюджетирование',
                info: {
                    text: 'Гибкое управление финансами',
                    additionalText: 'Настраиваемое бюджетирование с возможностью детализации по подразделениям, статьям затрат, проектам. Поддержка заявок, согласований, план-факт анализа.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Консолидация',
                info: {
                    text: 'Формирование сводной отчетности',
                    additionalText: 'Автоматическая консолидация данных из разных источников, включая дочерние компании. Поддержка трансформации, элиминации и подготовки отчетности по стандартам.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: '1С:АНАЛИТИКА',
                info: {
                    text: 'Аналитическая надстройка для 1С',
                    additionalText: 'Мощный инструмент для построения отчетов и анализа данных на базе 1С. Визуализация, фильтрация, группировка — всё в привычном интерфейсе.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            }
        ]
    },
    {
        name: 'ERP-системы',
        products: [
            {
                productName: '1С ERP Предприятие',
                info: {
                    text: 'Комплексная система управления бизнесом',
                    additionalText: 'Решение для автоматизации всех ключевых процессов: финансы, производство, закупки, продажи, логистика, персонал. Подходит для среднего и крупного бизнеса.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 60
            },
            {
                productName: '1С Комплексная автоматизация',
                info: {
                    text: 'Универсальное решение для управления',
                    additionalText: 'Интеграция учёта и управления: закупки, продажи, финансы, склад, зарплата и производство в единой системе. Подходит для компаний с типовым бизнесом.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: '1С комплексное управление финансами и бюджетирование',
                info: {
                    text: 'Финансовое планирование под контролем',
                    additionalText: 'Система позволяет управлять бюджетами, платежами, движением денежных средств и финансовыми планами, включая согласования и план-факт анализ.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 55
            },
            {
                productName: '1С управление финансами строительной организации',
                info: {
                    text: 'Учёт и планирование по строительным объектам',
                    additionalText: 'Решение адаптировано под нужды стройкомпаний: распределение затрат по проектам, финансовое планирование, управление договорами и субподрядами.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: '1С Астор (для розничных сетей)',
                info: {
                    text: 'ERP для торговли и ритейла',
                    additionalText: 'Автоматизация магазинов и сетей: от кассы до центрального офиса. Управление ассортиментом, ценообразованием, логистикой и аналитикой продаж.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 47
            },
            {
                productName: 'Отраслевые решения 1С Рейтинг',
                info: {
                    text: 'Готовые ERP-модули под специфику бизнеса',
                    additionalText: 'Разработки 1С Рейтинг для автотранспорта, строительства, нефтебаз, алкоголя и других сфер. Учитывают особенности законодательства Казахстана и отраслевую специфику.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: '1С Управление холдингом',
                info: {
                    text: 'ERP-решение для групп компаний',
                    additionalText: 'Функциональность для казначейства, бюджетирования, управления договорами, финансовой консолидации и МСФО. Поддерживает холдинговую структуру и многоуровневое управление.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 61
            }
        ]
    },
    {
        name: 'Недропользователям',
        products: [
            {
                productName: '1С комплексное управление финансами и бюджетирование',
                info: {
                    text: 'Полный контроль над финансами компании',
                    additionalText: 'Финансовое планирование и контроль исполнения бюджета в проектах недропользования. Учитываются специфика лицензий, контрактов и источников финансирования.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 55
            },
            {
                productName: '1С Зарплата и управление персоналом КОРП',
                info: {
                    text: 'Управление персоналом в сложных структурах',
                    additionalText: 'Учет штатного расписания, кадрового состава, графиков вахт, премий, доплат. Подходит для компаний с разветвлённой структурой и особым режимом труда.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: '1С Документооборот',
                info: {
                    text: 'Эффективное управление документацией',
                    additionalText: 'Автоматизация делопроизводства, согласований, учета исходящих и входящих документов, включая регламенты, лицензии и отчеты по недропользованию.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 10
            },
            {
                productName: '1С Техобслуживание и ремонт',
                info: {
                    text: 'Учёт ремонтов бурового и добывающего оборудования',
                    additionalText: 'Планирование и контроль ТО и ремонтов техники и агрегатов. Учет простоев, затрат на обслуживание, контроль регламентов и сроков.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Бюджетирование',
                info: {
                    text: 'Планирование затрат и инвестиций',
                    additionalText: 'Управление бюджетным процессом с разбивкой по скважинам, участкам, проектам. Учет капитальных вложений и операционных расходов.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 7
            },
            {
                productName: 'Казначейство',
                info: {
                    text: 'Управление платежами и потоками',
                    additionalText: 'Контроль за движением денежных средств по контрактам и проектам, учет заявок на оплату, формирование платёжных календарей.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 18
            },
            {
                productName: 'Управление складом (WMS)',
                info: {
                    text: 'Автоматизация складской логистики',
                    additionalText: 'Учет материалов и оборудования на месторождениях, автоматизация приёмки и выдачи, управление запасами и логистикой между объектами.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Учет спецодежды',
                info: {
                    text: 'Контроль СИЗ и формы',
                    additionalText: 'Выдача и списание спецодежды, учет по нормативам и срокам носки, распределение по сотрудникам, объектам и подразделениям.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Управление закупками',
                info: {
                    text: 'Закупки под нужды геологоразведки и добычи',
                    additionalText: 'Учет потребностей по объектам, автоматизация тендеров, контроль бюджета и статусов заказов. Снижение сроков и рисков снабжения.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 20
            }
        ]
    },
    {
        name: 'Улучшение бизнес-процессов',
        products: [
            {
                productName: '1С Зарплата и управление персоналом',
                info: {
                    text: 'Эффективный кадровый и зарплатный учет',
                    additionalText: 'Решение для автоматизации расчета зарплаты, учета рабочего времени, отпусков и больничных. Поддержка всех требований законодательства и отчетности.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: '1С Зарплата и управление персоналом КОРП',
                info: {
                    text: 'Расширенные HR-функции для крупных компаний',
                    additionalText: 'Подходит для компаний со сложной организационной структурой. Включает управление талантами, кадровым резервом, целевыми показателями и мотивацией.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: '1С Документооборот',
                info: {
                    text: 'Быстрая работа с документами и задачами',
                    additionalText: 'Организация потоков входящих, исходящих и внутренних документов, согласования, архива, задач. Ускоряет процессы и снижает рутинную нагрузку.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 10
            },
            {
                productName: '1С Техобслуживание и ремонт',
                info: {
                    text: 'Контроль технического состояния оборудования',
                    additionalText: 'Позволяет вовремя планировать ТО, учитывать ремонты, фиксировать неисправности. Помогает продлить срок службы техники и снизить издержки.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Бюджетирование',
                info: {
                    text: 'Финансовое планирование и контроль',
                    additionalText: 'Создание и управление бюджетами по подразделениям, статьям расходов, проектам. Поддержка план-факт анализа и гибкой настройки моделей.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 6
            },
            {
                productName: 'Казначейство',
                info: {
                    text: 'Оптимизация платежных процессов',
                    additionalText: 'Учет и контроль заявок на оплату, формирование графика платежей, контроль движения денежных средств. Удобно для многопрофильных компаний.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 18
            },
            {
                productName: 'Управление складом (WMS)',
                info: {
                    text: 'Эффективное управление логистикой',
                    additionalText: 'Автоматизация складских операций: приёмка, размещение, перемещение, сборка и отгрузка. Снижает количество ошибок и ускоряет обработку заказов.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Консолидация',
                info: {
                    text: 'Сводная отчетность по группе компаний',
                    additionalText: 'Объединение финансовых и управленческих данных из разных юридических лиц и систем. Поддержка трансформации и элиминации при подготовке отчетности.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Управление автотранспортом',
                info: {
                    text: 'Контроль и учет работы автопарка',
                    additionalText: 'Учет транспорта, путевых листов, расхода топлива, обслуживания и ремонтов. Повышает прозрачность логистических процессов и сокращает затраты.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Учет аренды',
                info: {
                    text: 'Автоматизация учета арендных отношений',
                    additionalText: 'Учет договоров аренды, начисление арендных платежей, контроль сроков и условий. Подходит для собственников, арендодателей и арендаторов.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Автоматизация хозяйственной деятельности для банка',
                info: {
                    text: 'Учет и контроль внутренних процессов банка',
                    additionalText: 'Решение охватывает процессы закупок, учета имущества, ремонтных работ, договоров и складского учета в кредитных организациях. Учитывает банковскую специфику.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Раздельный учет и ABcosting',
                info: {
                    text: 'Анализ затрат по направлениям и продуктам',
                    additionalText: 'Позволяет учитывать доходы и расходы в разрезе направлений деятельности и продуктов. Поддерживает ABC/ABM-методики для детального управленческого анализа.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Учет спецодежды',
                info: {
                    text: 'Полный контроль за СИЗ',
                    additionalText: 'Автоматизация выдачи, возврата и учета спецодежды и инвентаря. Поддержка учета по нормам, срокам носки, подразделениям и сотрудникам.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Управление закупками',
                info: {
                    text: 'Цифровизация закупочного процесса',
                    additionalText: 'Формирование заявок, выбор поставщиков, контроль исполнения договоров, учёт планов и бюджетов. Подходит для коммерческих и государственных организаций.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 20
            },
            {
                productName: 'Метод начисления для быстрого закрытия периода',
                info: {
                    text: 'Автоматизация начислений в конце месяца',
                    additionalText: 'Позволяет ускорить финансовое закрытие периода за счёт гибкой настройки правил начислений по затратам, запасам и обязательствам.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Битрикс',
                info: {
                    text: 'CRM и автоматизация продаж',
                    additionalText: 'Интеграция с Битрикс24: управление клиентами, задачами, сделками, документооборотом. Настройка процессов под особенности вашего бизнеса.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 49
            },
            {
                productName: '1С Промышленная безопасность',
                info: {
                    text: 'Контроль за соблюдением требований ПБ',
                    additionalText: 'Учет проверок, инструктажей, инцидентов, контроль выполнения предписаний и мероприятий. Актуально для производственных и опасных объектов.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Электронное обучение LMS',
                info: {
                    text: 'Обучение сотрудников в цифровом формате',
                    additionalText: 'Система управления обучением: проведение курсов, тестов, сертификаций. Поддержка внутренней академии, интеграция с кадровыми модулями.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: '1С MES',
                info: {
                    text: 'Оперативное управление производством',
                    additionalText: 'Система класса MES для диспетчеризации, учета и анализа производственных процессов в режиме реального времени. Повышает эффективность загрузки оборудования.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 41
            }
        ]
    },
    {
        name: 'Интеграция с ИИ / Кибернетика AI',
        products: [
            {
                productName: 'Seke.net',
                info: {
                    text: 'AI-платформа для управления финансами и снабжением',
                    additionalText: 'Интеллектуальный помощник для контроля закупок, бюджетов, остатков и денежных средств. Автоматизирует принятие решений на основе данных.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'SupplyBot (бот для МТО)',
                info: {
                    text: 'Автоматизация заявок на закупки',
                    additionalText: 'Чат-бот для формирования и согласования заявок на материально-техническое обеспечение. Упрощает и ускоряет работу снабжения.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Платёжка (бот для казначейство)',
                info: {
                    text: 'Быстрое создание заявок на оплату',
                    additionalText: 'Чат-бот помогает сотрудникам формировать заявки на оплату по регламентам и маршрутам согласования компании.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'Бот СтройСмета (бот для Стройка и сметы)',
                info: {
                    text: 'Сметные заявки без лишней бюрократии',
                    additionalText: 'Голосом или текстом создаёт заявки на поставку материалов по сметам. Удобен для прорабов и ПТО.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'BudgetAI (бот для Бюджетирование)',
                info: {
                    text: 'AI-помощник в планировании бюджета',
                    additionalText: 'Подсказывает оптимальные статьи бюджета на основе истории и логики компании. Облегчает составление и корректировку планов.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'СервисБот (бот для ТОиР)',
                info: {
                    text: 'ИИ для технического обслуживания и ремонта',
                    additionalText: 'Распознаёт документацию, заполняет формы ТОиР, формирует заявки на ремонт и снабжение по спецификациям.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'АвтоЛогика (бот для Автотранспорт)',
                info: {
                    text: 'Автоматизация логистики и ремонта транспорта',
                    additionalText: 'Распределяет грузы и задания по автотранспорту, формирует заявки на ТО и ремонт. Повышает оперативность логистики.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'ProjectBot (бот для Управление проектом)',
                info: {
                    text: 'AI-помощник в управлении задачами',
                    additionalText: 'Создаёт задачи, списывает время, собирает протоколы. Подходит для проектных команд и agile-форматов.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'СатуBot (бот для Розница)',
                info: {
                    text: 'Экспериментальный AI для розничной торговли',
                    additionalText: 'Разработка в стадии тестирования. Ищет пути улучшения клиентского опыта и взаимодействия персонала в магазинах.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'VendorSync (бот для поставщиков в ритейл)',
                info: {
                    text: 'Помощник для закупщиков и поставщиков',
                    additionalText: 'Информирует закупщика о наличии товаров у поставщиков. Автоматизация и ускорение закупочных решений.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'ЧатТорговец (бот продавец в магазин)',
                info: {
                    text: 'Чат-бот для онлайн-продаж',
                    additionalText: 'Принимает заказы через мессенджеры, помогает клиенту выбрать товар из меню и оформляет заказ. Полезен для малого ритейла.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'ДелоБот (бот Секретарь для ДО)',
                info: {
                    text: 'Автоматизация документооборота',
                    additionalText: 'Автоматизация документооборота: регистрация входящих/исходящих документов, напоминания, проверка сроков исполнения и шаблонов. Помощь в управлении задачами и согласованиями.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            },
            {
                productName: 'HRBuddy (бот Личный кабинет сотрудника)',
                info: {
                    text: 'Персональный AI-ассистент сотрудника',
                    additionalText: 'Запрос отпуска, просмотр расчетного листка, подписание документов — всё через чат. Упрощает взаимодействие с HR.'
                },
                feautures: {
                    price: 10000,
                    time: 'От 1 до 4 месяцев'
                },
                id: 1
            }
        ]
    }


]